import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { CombinedReducersType, ConfigActions } from "@redux/reducer";
import { Button, ButtonLayout, Modal, Body } from "@common/DynamicUikit";
import {
  iosAndroidGuHk,
  iosAndroidGuTw,
  iosAndroidUqHk,
  iosAndroidUqTw,
  isPC
} from "@util/helpers";
import { BRAND_LIST, COUNTRY } from "@type/index";

type IProps = {
  clickClose?: () => void;
};

const LoginModal = (props: IProps): any => {
  const { clickClose } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { region, isApp, brand_name, language } = useSelector(
    (store: CombinedReducersType) => store.config
  );

  const handlerJumpLogin = () => {
    switch (`${brand_name}${region}`) {
      case `${BRAND_LIST.UQ}${COUNTRY.HK}`: {
        if (isApp) {
          iosAndroidUqHk("goLogin", "");
        } else if (!isPC(brand_name, region)) {
          const _url = `${window.location.origin}/${language}/login?redirect=${window.location.href}&source=minisite`;
          window.location.href = _url;
        }
        break;
      }
      case `${BRAND_LIST.GU}${COUNTRY.HK}`: {
        if (isApp) {
          iosAndroidGuHk("goLogin");
        } else if (!isPC(brand_name, region)) {
          const _url = `${
            window.location.origin
          }/${region}/login?redirect=${window.location.pathname.substring(3)}${
            window.location.search
          }&source=minisite`;
          window.location.href = _url;
        }
        break;
      }
      case `${BRAND_LIST.UQ}${COUNTRY.TW}`: {
        if (isApp) {
          iosAndroidUqTw("goLogin");
        } else if (isPC(brand_name, region)) {
          const _url = `${window.location.origin}/${region}/${language}/login.html?redirect_url=${window.location.pathname}`;
          window.location.href = _url;
        } else {
          const _url = `${window.location.origin}/${region}/login?redirect=${window.location.href}`;
          window.location.href = _url;
        }
        break;
      }
      case `${BRAND_LIST.GU}${COUNTRY.TW}`: {
        if (isApp) {
          iosAndroidGuTw("goLogin");
        } else if (isPC(brand_name, region)) {
          const _url = `${window.location.origin}/${region}/${language}/login.html?redirect_url=${window.location.pathname}`;
          window.location.href = _url;
        } else {
          const _url = `${window.location.origin}/${region}/login?redirect=${window.location.href}`;
          window.location.href = _url;
        }
        break;
      }
      default:
        break;
    }
  };

  const handlerClose = () => {
    if (clickClose) {
      clickClose();
    }
    dispatch(ConfigActions.setShowLogin(false));
  };

  return (
    <Modal
      closeLabel={" "}
      closeTitle={t("text_a11y_close")}
      errors={[]}
      id="sm-1"
      labelElement="h5"
      onBackdropClick={undefined}
      onRequestClose={handlerClose}
      title={t("text_login_required")}
      titleId="modal-title"
      trapFocus
      variant="small"
      isOpen
      footer={
        <ButtonLayout reverseOnVertical={false} variant="fluid">
          <Button
            element="button"
            isSmall={false}
            variant="primary"
            width="fullWidth"
            data-testid="login-button"
            onClick={handlerJumpLogin}
          >
            {t("text_log_in")}
          </Button>
          <Button
            element="button"
            isSmall={false}
            variant="secondary"
            width="fullWidth"
            onClick={handlerClose}
            data-testid="close-button"
          >
            {t("text_app_update_dialog_cancel")}
          </Button>
        </ButtonLayout>
      }
    >
      <Body element="p" variant="standard">
        {t("text_login_request")}
      </Body>
    </Modal>
  );
};

export default LoginModal;
